import { render } from "./IconGooglePlay.vue?vue&type=template&id=71a8891e"
import script from "./IconGooglePlay.vue?vue&type=script&lang=js"
export * from "./IconGooglePlay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__